import React from "react";

const WaterLoader: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] p-8">
      {/* Water Drop Animation */}
      <div className="relative mb-6">
        <div className="relative w-20 h-20">
          {/* Main water drop */}
          <div className="absolute inset-0 rounded-full bg-primary animate-pulse"></div>

          {/* Animated ripples */}
          <div className="absolute inset-0 border-2 rounded-full border-primary animate-ping opacity-30"></div>
          <div
            className="absolute inset-0 border-2 rounded-full border-primary animate-ping opacity-20"
            style={{ animationDelay: "0.5s" }}
          ></div>

          {/* Water drop shape overlay */}
        </div>

        {/* Water waves */}
        <div className="absolute w-32 h-8 overflow-hidden transform -translate-x-1/2 -bottom-4 left-1/2">
          <div className="absolute bottom-0 left-0 w-full h-4 rounded-full bg-gradient-to-r from-transparent via-primary/20 to-transparent animate-pulse"></div>
          <div className="absolute bottom-0 left-0 w-full h-2 rounded-full bg-gradient-to-r from-transparent via-primary/30 to-transparent animate-ping"></div>
        </div>
      </div>

      {/* Loading text */}
      <div className="mb-2 text-lg font-medium text-primary animate-pulse">
        Chargement en cours...
      </div>

      {/* Loading dots */}
      <div className="flex space-x-1">
        <div className="w-2 h-2 rounded-full bg-primary animate-bounce"></div>
        <div
          className="w-2 h-2 rounded-full bg-primary animate-bounce"
          style={{ animationDelay: "0.1s" }}
        ></div>
        <div
          className="w-2 h-2 rounded-full bg-primary animate-bounce"
          style={{ animationDelay: "0.2s" }}
        ></div>
      </div>

      {/* Custom CSS for additional animations */}
      <style>{`
        @keyframes waterDrop {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }
        
        .water-drop {
          animation: waterDrop 2s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
};

export default WaterLoader;
